import { Input } from './FormField.js';

/**
 * 162: the search box above an admin list.
 *
 * One component for thirteen screens, so an operator meets the same control everywhere and a
 * screen added later cannot quietly ship a box with no label. `type="search"` is what gives the
 * browser its own clear affordance, and the accessible name is required rather than optional —
 * a bare input on a page with several controls is unreachable by anything but sight.
 *
 * It is deliberately CONTROLLED and dumb: the debounce and the page reset live in
 * `useListControls`, because they are behaviour rather than presentation and a screen must not be
 * able to render this without them.
 */
export function ListSearch({
  value,
  onChange,
  label,
  placeholder,
  testId,
}: {
  value: string;
  onChange: (next: string) => void;
  /** The accessible name, e.g. "Filter locations by name or city". */
  label: string;
  placeholder?: string;
  testId?: string;
}) {
  return (
    <div className="mb-4">
      <Input
        type="search"
        aria-label={label}
        data-testid={testId ?? 'list-search'}
        placeholder={placeholder ?? label}
        className="w-full sm:w-72"
        value={value}
        onChange={(e) => onChange((e.target as HTMLInputElement).value)}
      />
    </div>
  );
}
